/**
 * @desc 列表
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/transactionMain/list`, {
      method: "GET",

      ...options,
    }),
  );
}
